var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 24,
    viewBox: "-4 -4 118 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.016.217h71.202v18.601H.016z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fff",
    transform: "translate(0,10)",
    d: "M.016 .217 h107.202 v5.601 H.016z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M20.586 21.462h2.845V.304h-2.845z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M28.688 21.462h2.845V.304h-2.845z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M43.862 8.146c-2.904 0-5.267 2.379-5.267 5.302 0 2.923 2.363 5.302 5.267 5.302 2.905 0 5.267-2.379 5.267-5.302 0-2.923-2.362-5.302-5.267-5.302zm0 13.277c-4.368 0-7.922-3.578-7.922-7.975s3.554-7.974 7.922-7.974c4.369 0 7.923 3.577 7.923 7.974s-3.554 7.975-7.923 7.975z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M92.705 8.146c-2.904 0-5.266 2.379-5.266 5.302 0 2.923 2.362 5.302 5.266 5.302 2.905 0 5.267-2.379 5.267-5.302 0-2.923-2.362-5.302-5.267-5.302zm0 13.277c-4.368 0-7.922-3.578-7.922-7.975s3.554-7.974 7.922-7.974c4.369 0 7.923 3.577 7.923 7.974s-3.554 7.975-7.923 7.975z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.182)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M63.639 13.23a5.025 5.025 0 01-2.78-.706l-2.4 1.394V8.055c0-1.699.827-3.31 2.248-4.226l.152-.094a5.02 5.02 0 012.58-.71c2.879 0 5.197 2.413 5.067 5.34-.117 2.632-2.25 4.765-4.867 4.866zm5.42-10.59A7.695 7.695 0 0063.43.216a7.737 7.737 0 00-4.197 1.236c-2.179 1.406-3.48 3.84-3.48 6.512v10.853l5.552-3.223a7.717 7.717 0 002.43.294c4.012-.155 7.296-3.438 7.476-7.475a7.807 7.807 0 00-2.15-5.775z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M2.712 8.364c-.13-2.926 2.188-5.34 5.066-5.34a5.02 5.02 0 012.733.805c1.42.917 2.247 2.527 2.247 4.226v5.863l-2.4-1.394a5.024 5.024 0 01-2.78.707c-2.616-.101-4.75-2.234-4.866-4.867zm-2.704.05c.18 4.037 3.463 7.32 7.476 7.475a7.716 7.716 0 002.429-.294l5.552 3.223V7.965c0-2.672-1.301-5.106-3.48-6.512A7.738 7.738 0 007.788.216c-2.147 0-4.146.861-5.63 2.423a7.807 7.807 0 00-2.15 5.775z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M109.857.048c-3.33 0-5.163 1.809-5.163 5.094v16.32h2.845V9.232h2.318V6.368h-2.318V5.142c0-.78.138-1.339.41-1.66.322-.379.964-.57 1.908-.57h.108V.047h-.108"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M80.99 5.125c-4.643 0-5.337 3.732-5.337 5.957v10.38h2.845v-10.38c0-2.006.397-3.094 2.492-3.094h.108V5.125h-.108"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.586 21.462h2.845V.304h-2.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M28.688 21.462h2.845V.304h-2.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.862 8.146c-2.904 0-5.267 2.379-5.267 5.302 0 2.923 2.363 5.302 5.267 5.302 2.905 0 5.267-2.379 5.267-5.302 0-2.923-2.362-5.302-5.267-5.302zm0 13.277c-4.368 0-7.922-3.578-7.922-7.975s3.554-7.974 7.922-7.974c4.369 0 7.923 3.577 7.923 7.974s-3.554 7.975-7.923 7.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M92.705 8.146c-2.904 0-5.266 2.379-5.266 5.302 0 2.923 2.362 5.302 5.266 5.302 2.905 0 5.267-2.379 5.267-5.302 0-2.923-2.362-5.302-5.267-5.302zm0 13.277c-4.368 0-7.922-3.578-7.922-7.975s3.554-7.974 7.922-7.974c4.369 0 7.923 3.577 7.923 7.974s-3.554 7.975-7.923 7.975z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.182)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M63.639 13.23a5.025 5.025 0 01-2.78-.706l-2.4 1.394V8.055c0-1.699.827-3.31 2.248-4.226l.152-.094a5.02 5.02 0 012.58-.71c2.879 0 5.197 2.413 5.067 5.34-.117 2.632-2.25 4.765-4.867 4.866zm5.42-10.59A7.695 7.695 0 0063.43.216a7.737 7.737 0 00-4.197 1.236c-2.179 1.406-3.48 3.84-3.48 6.512v10.853l5.552-3.223a7.717 7.717 0 002.43.294c4.012-.155 7.296-3.438 7.476-7.475a7.807 7.807 0 00-2.15-5.775z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.712 8.364c-.13-2.926 2.188-5.34 5.066-5.34a5.02 5.02 0 012.733.805c1.42.917 2.247 2.527 2.247 4.226v5.863l-2.4-1.394a5.024 5.024 0 01-2.78.707c-2.616-.101-4.75-2.234-4.866-4.867zm-2.704.05c.18 4.037 3.463 7.32 7.476 7.475a7.716 7.716 0 002.429-.294l5.552 3.223V7.965c0-2.672-1.301-5.106-3.48-6.512A7.738 7.738 0 007.788.216c-2.147 0-4.146.861-5.63 2.423a7.807 7.807 0 00-2.15 5.775z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M109.857.048c-3.33 0-5.163 1.809-5.163 5.094v16.32h2.845V9.232h2.318V6.368h-2.318V5.142c0-.78.138-1.339.41-1.66.322-.379.964-.57 1.908-.57h.108V.047h-.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M80.99 5.125c-4.643 0-5.337 3.732-5.337 5.957v10.38h2.845v-10.38c0-2.006.397-3.094 2.492-3.094h.108V5.125h-.108"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ec75495f02a8c82971e26fbef19a258e.svg";
export { ForwardRef as ReactComponent };